export class CreateKeyValueRequest {
    
    public descripcion : string="";
}